export default class ParametrosObtencionPresolicitud {
    constructor(
        public numeroSolicitud?: number,
        public cedulaBeneficiario?: string,
        public cedulaFallecido?: string,
        public idTransFirma?: string
    ) {}
}